import React from "react";

import "../styles.scss";
import "../scripts";

import {
  secondaryBlock,
  SecondaryBlockSize,
  KameleonElement,
  SecondaryBlockConfig,
  getDefaultProps,
} from "@kameleon-core/lib";
import { Box } from "theme-ui";
import { Variants } from "@kameleon-util/global-theme";
import blockinfo from "./blockinfo.json";
import defaults from "./defaults.json";
import { DialogType, layoutOptions } from "./types/prop-types";

/** Dialog Secondary */
const blockConfig: SecondaryBlockConfig = {
  blockSize: SecondaryBlockSize.ExtraSmall,
};

export const Dialog = secondaryBlock<DialogType>(
  blockConfig,
  ({
    primaryButtonText,
    primaryButtonLink,
    secondaryButtonText,
    secondaryButtonLink,
    tertiaryButtonText,
    tertiaryButtonLink,
    layoutProps,
    icon,
    rightText,
    link,
    leftText,
  }: DialogType) => {
    const hasButtons =
      primaryButtonText || secondaryButtonText || tertiaryButtonText;

    return (
      <Box className="secondary-dialog-extrasmall-v1">
        <Variants.ButtonGroup
          primaryButtonText={primaryButtonText}
          primaryButtonLink={primaryButtonLink}
          secondaryButtonText={secondaryButtonText}
          secondaryButtonLink={secondaryButtonLink}
          tertiaryButtonText={tertiaryButtonText}
          tertiaryButtonLink={tertiaryButtonLink}
        />
        <Box className="w-layout-grid list-component-xsmall">
          <Box
            className={`list-item-xsmall item-xsmall ${hasButtons && "top"}`}
          >
            <Variants.BoxGrey
              hasBg={layoutProps.showItemBackground}
              className={`item-xsmall ${
                layoutProps.showItemBackground && "box-padding"
              }`}
            >
              {icon && (
                <Box className="icon-wrapper padding-right-xsmall w-embed">
                  <Variants.IconTiny
                    hasBg={layoutProps.showIconBackground}
                    icon={icon}
                  />
                </Box>
              )}
              <Box className="text-content">
                <Variants.ParagraphTiny className={!link ? "quote" : ""}>
                  {leftText}
                </Variants.ParagraphTiny>
                {leftText && rightText && (
                  <Variants.IconTiny icon="bi:dash" hasBg={false} />
                )}
                <Variants.ParagraphTiny bold>
                  {link ? (
                    <Variants.LinkUnderline as="strong" href={link}>
                      {rightText}
                    </Variants.LinkUnderline>
                  ) : (
                    rightText
                  )}
                </Variants.ParagraphTiny>
              </Box>
            </Variants.BoxGrey>
          </Box>
        </Box>
      </Box>
    );
  }
);

Dialog.defaultProps = getDefaultProps<DialogType>(defaults);

export const Element: KameleonElement = {
  component: Dialog,
  blockInfo: blockinfo,
  defaultProps: {
    layoutProps: defaults.layoutProps,
    contentProps: defaults.contentProps,
  },
  layoutOptions,
};
